interface LogPurchaseProps {
  googleMeasurementId: string
  purchaseId: string
  purchaseValue: number
  currency: string
}

// eslint-disable-next-line no-undef
const gtag: Gtag = function () {
  window.dataLayer.push(arguments)
  // eslint-disable-next-line no-undef
} as Gtag

const useGoogleConversionTracker = () => {
  // function to log the event
  // send_to ensures that it goes to the venue's GA, even if there's a GA loaded for ES too
  // the transaction_id is a unique identifier for Google to ensure events aren't double counted
  const logPurchaseEvent = ({ googleMeasurementId, purchaseId, purchaseValue, currency }: LogPurchaseProps) => {
    gtag('config', googleMeasurementId, { send_page_view: false })
    gtag('event', 'purchase', {
      send_to: googleMeasurementId,
      transaction_id: purchaseId,
      value: purchaseValue,
      currency,
    })
  }

  return {
    logPurchaseEvent,
  }
}
export default useGoogleConversionTracker
